export const size5MB = ( value: number ): boolean => {
  const size = ( value / ( 1024 * 1024 )).toFixed( 2 );
  return !( parseFloat( size ) > 5 );
};
